import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../../theme/theme";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/config/config";
import { useDispatch, useSelector } from "react-redux";
import {
  followCreator,
  getAllCreators,
  getUserById,
  unFollowCreator,
  unSubscribeCreator,
} from "../../redux/actions/user.dispatcher";
import SubscribeVideoDrawer from "../Common/SubscribeVideoDrawer";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const SingleCreator = ({ item, setup }) => {
  const dispatch = useDispatch();
  const mediumScreen = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();
  const [drawerState, setDrawerState] = useState(false);
  const [creatorData, setCreatorData] = useState(null);
  const [success, setSuccess] = useState(false);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { userData } = useSelector((state) => state.user);
  const [following, setFollowing] = useState(userData?.following || []);
  const [subscribed, setSubscribed] = useState(userData?.subscribed || []);

  const handleFollow = async (id) => {
    try {
      // Check if the user is already followed
      if (!following.includes(id)) {
        // Unfollow logic
        const resp = await followCreator(id);
        // Remove the id from the following array

        if (resp) {
          dispatch(getUserById(userData.id));
          setFollowing((prev) => [...prev, id]);
        }
      } else {
        // Follow logic
        const resp = await unFollowCreator(id);
        // Add the id to the following array
        if (resp) {
          dispatch(getUserById(userData.id));
          setFollowing((prev) => prev.filter((fid) => fid !== id));
        }
      }
    } catch (err) {
      console.error("Error updating follow status:", err);
    }
  };

  const handleUnsubscribe = async (id, creatorId) => {
    try {
      const response = await unSubscribeCreator(id);
      if (response) {
        dispatch(getAllCreators());
        dispatch(getUserById(userData.id));
        setSubscribed((prev) => prev.filter((fid) => fid !== creatorId));
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   if (userData?.id) {
  //     dispatch(getUserById(userData.id));
  //   }
  // }, [following, dispatch, userData?.id]);

  return (
    <Elements stripe={stripePromise}>
      <Box>
        <img
          src={item?.avatar || require("../../assets/images/user.jpg")}
          alt="content"
          style={{
            width: "100%",
            height: smallScreen ? "100px" : "240px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />

        {/* OverLay Text */}
        {/* <Box
        className="overlay"
        sx={{
          position: "absolute",
          bottom: "39%",
          left: 0,
          width: "100%",
          height: "61%",
          borderRadius: "8px",
          background:
            "linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 1))",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          opacity: 0,
          transition: "opacity 0.3s ease-in-out",
          py: 2,
          px: 3,
          cursor: "pointer",
        }}
      >
        <Stack
                    direction="row"
                    sx={{
                      gap: 1,
                      pb: 1,
                      borderBottom: `1px solid ${colors.primary}`,
                    }}
                  >
                    <EmojiEventsOutlined
                      sx={{ color: colors.primary, fontSize: "16px" }}
                    />
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontFamily: "Inter-SemiBold",
                        textAlign: "center",
                        color: colors.primary,
                      }}
                    >
                      ACHIEVEMENTS{"   "}
                    </Typography>
                  </Stack>
                  {item.achievements.map((i) => (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter-Regular",
                        textAlign: "center",
                        mt: 1,
                      }}
                    >
                      {i}
                    </Typography>
                  ))}
      </Box> */}

        {/* Content */}
        <Box sx={{ pt: 1 }}>
          <Typography
            sx={{
              color: colors.textColor,
              fontSize: smallScreen ? "18px" : "22px",
              fontFamily: "Inter-SemiBold",
              cursor: "pointer",
            }}
            onClick={() => {
              if (setup) {
                return;
              }
              if (item?.id == userData?.id) {
                navigate(`/creator/${userData?.id}`);
              } else {
                navigate(`/profile/${item?.id}`);
              }
            }}
          >
            {item?.firstName + " " + item?.lastName}

            {/* <Typography
                    component={"span"}
                    sx={{
                      color: colors.primary,
                      fontSize: "12px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "22px",
                    }}
                  >
                    {item.followers + " "} Followers
                  </Typography> */}
          </Typography>

          {/* <Box
                  sx={{
                    border: "1px solid #00000033",
                    px: 2,
                    py: 1,
                    display: "inline-block",
                  }}
                >
                  <Typography
                    sx={{
                      color: colors.textColor,
                      fontSize: "10px",
                      fontFamily: "Inter-Medium",
                    }}
                  >
                    {item.tags}
                  </Typography>
                </Box> */}
          <Typography
            sx={{
              mt: 1,
              color: "#00000080",
              fontSize: "13px",
              fontFamily: "Inter-Regular",
              overflow: "hidden",
              display: "-webkit-box", // ✅ REQUIRED for WebkitLineClamp
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: mediumScreen ? 2 : 2, // ✅ Works properly now
              textOverflow: "ellipsis",
              wordBreak: "break-word", // Prevents breaking long words incorrectly
            }}
          >
            {item?.bio}
          </Typography>
          <Stack
            direction="column"
            sx={{
              alignItems: smallScreen ? "left" : "center",
              gap: smallScreen ? 0 : 2,
            }}
          >
            <SecondaryBtn
              text={following?.includes(item.creatorId) ? "Unfollow" : "Follow"}
              noIcon
              width="100%"
              noMb
              onClick={() => {
                handleFollow(item.creatorId);
              }}
            />
            <CustomBtn
              text={!item?.isSubscribed ? "Subscribe" : "Unsubscribe"}
              filled
              noIcon
              width="100%"
              noMb
              onClick={() => {
                if (!item?.isSubscribed) {
                  if (!smallScreen) {
                    setDrawerState(true);
                    setCreatorData(item);
                  } else {
                    navigate("/subscriptionform/creator", {
                      state: {
                        creatorData: item,
                        setup: setup || null,
                      },
                    });
                  }
                } else {
                  handleUnsubscribe(item.id, item.creatorId);
                }
              }}
            />
          </Stack>
        </Box>
        <SubscribeVideoDrawer
          drawerState={drawerState}
          setDrawerState={setDrawerState}
          setSuccess={setSuccess}
          type="creator"
          creatorData={creatorData}
        />
      </Box>
    </Elements>
  );
};

export default SingleCreator;
